
import 'rxjs';
import generateTreePro from '../reducers/merkle-tree.js';
import * as actions from '../actions.js';

export function merkleTree(action$, store) {
    return action$.ofType('MERKLE-ADD-TEXT', 'MERKLE-UPDATE-FILES')
        .delay(1000)
        .flatMap(function processText() {
            const inputs = store.getState().merkle.leafInputs,
                leafHashes = inputs.map(x => x.hash);

            return !leafHashes.length ? Promise.resolve({type:'NO-OP'}) : generateTreePro(leafHashes, inputs)
                .then(function done(tree) {
                    return actions.updateMerkleTree(tree);
                });
        });
}

export function merkleFiles(action$, store) {
    return action$.ofType('MERKLE-ADD-FILES')
        //.delay(1000)
        .flatMap(function processFiles() {
            const filesToRead = store.getState().merkle.stagedFiles;

            const promises = Array.prototype.map.call(filesToRead, function go(file) {
                return new Promise(function pro(resolve, reject) {
                    const reader = new FileReader();
                    reader.onload = function read(ev) {
                        resolve(ev.target.result);
                    };
                    reader.readAsText(file);
                });
            });

            return Promise.all(promises)
                .then(function done(fileContents) {
                    const zipped = fileContents.map(function merge(content, ind) {
                        return {
                            filename: filesToRead[ind].name,
                            contents: content,
                        };
                    })
                    return actions.updateMerkleFiles(zipped);
                })
        });
}



// WEBPACK FOOTER //
// ./src/epics/merkle-epics.js